/**
 * DetailSection — a titled card wrapper for grouping DetailFields on view/detail
 * screens. Optional icon and right-aligned actions.
 */
import { ReactNode } from 'react';

interface DetailSectionProps {
  title: string;
  /** PrimeIcon class, e.g. 'pi pi-sitemap'. */
  icon?: string;
  /** Right-aligned header actions. */
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

const DetailSection = ({ title, icon, actions, children, className = '' }: DetailSectionProps) => (
  <div className={`rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800 ${className}`}>
    <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-ink">
        {icon && <i className={`${icon} text-indigo-600 dark:text-indigo-400`} />}
        {title}
      </h3>
      {actions}
    </div>
    <div className="p-4">{children}</div>
  </div>
);

export default DetailSection;
